module.exports = __webpack_public_path__ + "./images/9a85decd37d9455a061a93158ce87cb1.webp";